export function inputRegexValidation(text: string) {
    try {
        if (text.length === 0) {
            return false;
        }
        const regx = /<|\/\/|>|<iframe|http:|https:/g;
        if (regx.test(text) || /\$/.test(text)) {
            return false;
        }
        return true;
    } catch {
        return false;
    }
}

/** Default country code for phone validation (aligned with backend ProcessingConstants.DEFAULT_COUNTRY_CODE) */
export const DEFAULT_COUNTRY_CODE = 'IN';

/**
 * Validates phone number for default country (IN). Mirrors backend MobileNumberValidator:
 * - Empty → valid
 * - Length !== 10 → invalid
 * - For IN: 10 digits, mobile must start with 6, 7, 8 or 9 (isPossibleNumber semantics)
 */
export function phoneNumberValidation(phoneNumber: string) {
    if (phoneNumber == null || phoneNumber.length === 0) {
        return true;
    }
    if (phoneNumber.length !== 10) {
        return false;
    }
    // IN mobile: exactly 10 digits, no spaces; leading digit 6–9 (possible Indian mobile)
    return /^[6-9]\d{9}$/.test(phoneNumber);
}

export function emailValidation(email: string) {
    if (email.length === 0) return false;
    // Reject emails containing any whitespace (e.g. "user @gmail.com")
    if (/\s/.test(email)) return false;
    const regex1 = new RegExp(
        "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@" +
            '[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?' +
            '(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$'
    );

    const regex2 = /.+@.+\..+/;

    return regex1.test(email) && regex2.test(email);
}

export function panValidation(panNumber: string) {
    try {
        const regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        return regpan.test(panNumber);
    } catch {
        return false;
    }
}

export function gstValidation(gstNumber: string) {
    try {
        const regGst =
            /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        return regGst.test(gstNumber);
    } catch {
        return false;
    }
}

export function gstPanValidation(
    gstNumber: string,
    panNumber: string,
    gstApplicable: boolean
) {
    try {
        if (!gstApplicable) {
            return true;
        }
        if (!gstNumber || gstNumber.length === 0) return false;
        if (!gstValidation(gstNumber)) {
            return false;
        }
        const gstPan = gstNumber.substring(2, 12);
        return gstPan === panNumber;
    } catch {
        return false;
    }
}
